import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UrlService } from '../url.service';
import { CallbackContext } from '../callback-context';
import { OpenIdConfiguration } from '../../oidc-security.service';
import { OidcHttpService } from '../../http/oidc-http.service';

@Injectable({ providedIn: 'root' })
export class RefreshTokenCallbackHandlerService {
  constructor(
    private readonly urlService: UrlService,
    private readonly oidcHttpService: OidcHttpService
  ) {}

  // STEP 2 Refresh Token
  refreshSessionWithRefreshToken(
    callbackContext: CallbackContext,
    config: OpenIdConfiguration
  ): Observable<CallbackContext> {
    const tokenEndpoint = config.authWellknownEndpoints.tokenEndpoint;

    if (!tokenEndpoint) {
      return throwError(() => new Error('Token Endpoint not defined'));
    }

    const data = this.urlService.createBodyForCodeFlowRefreshTokensRequest(callbackContext.refreshToken, config);
    return this.oidcHttpService.postCapacitorHttp(tokenEndpoint, data).pipe(
      switchMap((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.data.state = callbackContext.state;
          callbackContext.authResult = response.data;
          return of(callbackContext);
        } else {
          const errorMessage = `OidcService refresh request ${config} ${response.status}`;
          return throwError(() => new Error(errorMessage));
        }
      })
    );
  }
}
